module.exports = __webpack_public_path__ + "static/Gotham-BookItalic-5b7fc2e3e7a607eee241e82f094c8cdd.woff2";